import { useEffect, useState } from 'react';
import type { default as GSAPType } from 'gsap';
import type { default as ScrollTriggerType } from 'gsap/ScrollTrigger';
import { loadGSAP } from '@/lib/gsap';

interface UseGSAPResult {
  gsap: typeof GSAPType | null;
  ScrollTrigger: typeof ScrollTriggerType | null;
  ready: boolean;
}

export const useGSAP = (): UseGSAPResult => {
  const [modules, setModules] = useState<UseGSAPResult>({
    gsap: null,
    ScrollTrigger: null,
    ready: false,
  });

  useEffect(() => {
    loadGSAP().then(({ gsap, ScrollTrigger }) => {
      setModules({ gsap, ScrollTrigger, ready: true });
    });
  }, []);

  return modules;
};
